module.exports = __webpack_public_path__ + "static/media/fullscreen-feedback.74f55f94.png";